import { useNavigate } from "react-router-dom"; 
import React, { useState, useEffect } from 'react'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import { loadSettings, getAlertLvl, epochToHumanReadableTS } from '../components/Functions'

import LoadingOverlay from 'react-loading-overlay-ts';
import MuiDialogAlert from '../components/MuiDialogAlert';

import axios from 'axios';

const columns_sensors_data = [
    { field: 'device_id',   headerName: 'Device ID',    width: 150, headerClassName: 'datagrid_header_default' },
    { field: 'location',    headerName: 'Location',     width: 200, headerClassName: 'datagrid_header_default' },
    { 
        field: 'filled_lvl',  headerName: 'Filled Level', width: 200,
        renderCell: (params) => (
            <div dangerouslySetInnerHTML={{ __html: params.value }} />
        ),
    },
    { 
        field: 'temperature', headerName: 'Temperature',  width: 200,
        renderCell: (params) => (
            <div dangerouslySetInnerHTML={{ __html: params.value }} />
        ),
    },
    {
        field: 'batt_lvl', headerName: 'Battery Level', width: 200,
        renderCell: (params) => (
            <div dangerouslySetInnerHTML={{ __html: params.value }} />
        )
    },

]


const Sensors = () => {

    let navigate = useNavigate();

    const [sensorTableData, setSensorTableData] = useState([])
    const [settings, setSettings] = useState({
        "color_codes": {},
        "map": {},
        "alerts": {}
    })
    const [loadingActive, setLoadingActive] = useState(false);
    const [initLoad, setInitLoad] = useState(false)
    const [pageLoaded, setPageLoaded] = useState(false)

    const [modalHeader, setModalHeader] = useState("");
    const [modalBody, setModalBody] = useState("");
    const [modalHtml, setModalHtml] = useState("");
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    useEffect(() => {

        const getSettings = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getSettings";
                console.log(`URL: ${url}`);

                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }

    
                // Set the retrieved data to the state
                setSettings(loadSettings(response.data));
                setInitLoad(true)
                console.log("Set Setting finished")
                setLoadingActive(false);

            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load settings data")
                setShowModal(true) 
               
            }
        };

            setLoadingActive(true);
            getSettings()

    }, [])

    useEffect(() => {
        const getDevicesData = async () => {
            try {
                // Make a GET request using Axios
                let url = process.env.REACT_APP_API_SERVER + "/getDevicesData";
                console.log(`URL: ${url}`);
                const response = await axios.get(url, {
                    params: {
                        "api_user": JSON.parse(localStorage.getItem('user'))
                    }
                });

                if (response.data.status === "API_AUTH_ERROR") {
                    // Force user to re-login if unable to autheticate with the API
                    navigate("/logout")
                }

                console.log(response.data);
                // Set the retrieved data to the state

                let return_data = response.data
                let tmp_array = []

                for (let index = 0; index < return_data.length; index++) {
                    const data = return_data[index];
                    let tmp_json = {}

                    tmp_json.id = data.id
                    tmp_json.device_id = data.device_id
                    tmp_json.location = data.settings.description

                    let vol_percent = data.status.latest_transaction.VOLUME.vol_percent
                    let vol_last_update = epochToHumanReadableTS(data.status.latest_transaction.VOLUME.vol_update_epoch)

                    let alert_lvl = getAlertLvl(vol_percent, settings.alerts)
                    console.log(alert_lvl)

                    tmp_json.filled_lvl = `
                        <table>
                            <tr>
                                <td width='20px'>    
                                    <div style='width:16px; height:16px; border-radius:50%; background-color:${alert_lvl.color_code}; margin-right: 5px;'></div>
                                </td>
                                <td>
                                    <div class='sensor_table_large_text'>
                                        ${Number(vol_percent).toFixed(1)}%   
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan='2'>    
                                    <div class='sensor_table_small_text'>
                                        (${vol_last_update})
                                    </div>
                                </td>
                            </tr>
                        </table>
                    `

                    let temperature = data.status.latest_transaction.TEMPERATURE.temperature
                    let temp_last_update = epochToHumanReadableTS(data.status.latest_transaction.TEMPERATURE.temp_update_epoch)
                    tmp_json.temperature = `
                        <div class='sensor_table_large_text'>${Number(temperature).toFixed(1)}°C</div>   
                        <div class='sensor_table_small_text'>(${temp_last_update})</div>
                    `

                    let batt_lvl = data.status.latest_transaction.BATTERY.batt_percent
                    let batt_lvl_last_update = epochToHumanReadableTS(data.status.latest_transaction.BATTERY.batt_update_epoch)
                    tmp_json.batt_lvl = `
                        <div class='sensor_table_large_text'>${Number(batt_lvl).toFixed(1)}%</div>   
                        <div class='sensor_table_small_text'>(${batt_lvl_last_update})</div>
                    `

                    tmp_array.push(tmp_json)
                }

                setSensorTableData(tmp_array)
                setPageLoaded(true)
                setLoadingActive(false);


            } catch (error) {
                // Handle errors if the request fails
                console.log(error);
                setModalHeader("Error")
                setModalBody("Unable to load sensor data")
                setShowModal(true) 
            }
        };
        if (initLoad) {    
            setLoadingActive(true);
            getDevicesData()
        }

    },[settings])


    return (
        <main >
            <div align="left" style={{ height: "100%" }}>
                <LoadingOverlay
                    active={loadingActive}
                    spinner
                    text="Loading ..."
                >
        {
            pageLoaded &&
            <>
            <div className='page_title'>SENSORS</div>
            <div className='data_container'>
            <div className='data_container_header'>Sensors</div>
                <div className='datagrid_content'>
                    <div style={{ width: "100%" }}>
                        <DataGrid
                            className='datagrid_default'
                            rows={sensorTableData}
                            columns={columns_sensors_data}
                            pageSize={50}
                            disableVirtualization
                            disableSelectionOnClick
                            components={{ Toolbar: GridToolbar }}
                            sx={{
                                '& .MuiTablePagination-selectLabel': {
                                    paddingTop: '15px'
                                },
                                '& .MuiTablePagination-displayedRows': { paddingTop: '15px' },
                                '& .MuiDataGrid-cell': { fontSize: 14 },
                                '& .MuiDataGrid-columnHeader': {
                                    fontSize: 16,
                                    color: '#1B9982',
                                    fontWeight: 900
                                },
                                '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell--editing': {
                                    outline: 'none', // Remove outline when cell is focused or editing
                                    border: 'none', // Remove border when cell is focused or editing
                                },
                                '& .MuiDataGrid-root': {
                                    border: 'none'
                                },
                                '& .MuiButton-root, & .MuiButtonBase-root': {
                                    color: '#1B9982', // Change this to your desired color
                                },
                                '& .MuiTablePagination-root': {
                                    color: '#FFFFFF', // Change this to your desired color
                                },
                            }} />
                    </div>
                </div>
            </div></>
        }


                    <MuiDialogAlert
                        showModal={showModal}
                        handleClose={handleClose}
                        html={modalHtml}
                        bodyContent={modalBody}
                        title={modalHeader}
                        bodyClass="whitespace"
                    />
                </LoadingOverlay>
            </div>
        </main>
    )
}

export default Sensors